"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const ActionTypes = require("../../actionTypes/project/change");
const status_1 = require("../../status");
exports.initialState = {
    isModalOpen: false,
    customerChange: {
        projectUuid: '',
        prevCustomerUuid: '',
        newCustomerUuid: '',
        syncMatchingGroupCategoryLinksByName: false
    },
    fetchStatus: status_1.RequestStatusFactory.fetch.standby(),
    failedReason: ''
};
const isModalOpenLens = monocle.Lens.fromProp('isModalOpen');
const customerChangeLens = monocle.Lens.fromProp('customerChange');
const fetchStatusLens = monocle.Lens.fromProp('fetchStatus');
const failedReasonLens = monocle.Lens.fromProp('failedReason');
exports.methods = {};
exports.methods[ActionTypes.IS_MODAL_OPEN] = (state) => isModalOpenLens.modify((status) => !status)(state);
exports.methods[ActionTypes.CLEAR_ALL] = () => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.CHANGE_CUSTOMER_REQUEST] = (state, action) => fp.function.flow(customerChangeLens.set(action.payload), fetchStatusLens.set(status_1.RequestStatusFactory.fetch.busy()))(state);
exports.methods[ActionTypes.CHANGE_CUSTOMER_SUCCESS] = (state) => fetchStatusLens.set(status_1.RequestStatusFactory.fetch.success())(state);
exports.methods[ActionTypes.CHANGE_CUSTOMER_FAILURE] = (state, action) => {
    var _a, _b;
    return fp.function.flow(fetchStatusLens.set(status_1.RequestStatusFactory.fetch.failure()), failedReasonLens.set((_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : ''))(state);
};
//# sourceMappingURL=change.js.map